import { Navigation } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'

import { useReviewsCarouselVariants } from '../../../Theme'
import { SectionHeader } from '../../../UiBlocks'
import { REVIEWS_CAROUSEL_BREAKPOINTS } from '../../constants'
import { LABELS } from '../../lib'
import { NavigationButton } from '../shared'
import { ReviewCard } from './ReviewCard'
import { ReviewsCarouselSkeleton } from './ReviewsCarouselSkeleton'

import type { ReviewCard as ReviewCardType } from '../../types'

interface ReviewsCarouselProps {
  /** Transformed review cards */
  reviews: ReviewCardType[]
  /** Loading state - shows skeleton */
  isLoading?: boolean
}

/**
 * ReviewsCarousel - "Ce spun clienții noștri" homepage section.
 *
 * Compact Swiper carousel (2 / 3 / 5 responsive) of the latest approved product
 * reviews. Hidden when there are no reviews. Card sizing matches product tiles.
 */
export function ReviewsCarousel({ reviews, isLoading = false }: ReviewsCarouselProps) {
  const {
    reviewsCarouselSectionVariants,
    reviewsCarouselSwiperVariants,
    reviewsCarouselSlideVariants,
  } = useReviewsCarouselVariants()

  if (isLoading) {
    return <ReviewsCarouselSkeleton />
  }

  if (reviews.length === 0) {
    return null
  }

  const enableLoop = reviews.length > 5

  return (
    <section className={reviewsCarouselSectionVariants()}>
      <SectionHeader size="lg" centered>
        {LABELS.REVIEWS_SECTION_TITLE}
      </SectionHeader>

      <Swiper
        modules={[Navigation]}
        spaceBetween={0}
        slidesPerView={2}
        loop={enableLoop}
        navigation={{
          prevEl: '.reviews-swiper-prev',
          nextEl: '.reviews-swiper-next',
        }}
        breakpoints={REVIEWS_CAROUSEL_BREAKPOINTS}
        className={reviewsCarouselSwiperVariants()}
      >
        {reviews.map((review) => (
          <SwiperSlide key={review.reviewId} className={reviewsCarouselSlideVariants()}>
            <ReviewCard review={review} />
          </SwiperSlide>
        ))}

        <NavigationButton direction="prev" size="product" className="reviews-swiper-prev" />
        <NavigationButton direction="next" size="product" className="reviews-swiper-next" />
      </Swiper>
    </section>
  )
}
